// Generated by scripts/gen-api.mjs from api/openapi.yaml. Do not edit.
// contract version 0.1.0
export type JsonSchema = {
  $ref?: string; type?: string; enum?: readonly string[]; pattern?: string; format?: string;
  maxLength?: number; minLength?: number; minItems?: number; maxItems?: number;
  minimum?: number; maximum?: number; required?: readonly string[];
  properties?: Record<string, JsonSchema>; items?: JsonSchema; allOf?: readonly JsonSchema[];
  additionalProperties?: boolean | JsonSchema; default?: unknown;
};
export const contractVersion = "0.1.0";
export const schemas: Record<string, JsonSchema> = {
  "EnvironmentName": {
    "type": "string",
    "pattern": "^[a-z]([-a-z0-9]{0,28}[a-z0-9])?$",
    "maxLength": 30
  },
  "CustomerId": {
    "type": "string",
    "pattern": "^[a-z][a-z0-9-]{1,30}$"
  },
  "SourceEnvironment": {
    "type": "string",
    "pattern": "^[a-z][a-z0-9-]{1,30}$"
  },
  "Source": {
    "type": "object",
    "required": [
      "customer",
      "environment"
    ],
    "properties": {
      "customer": {
        "$ref": "#/components/schemas/CustomerId"
      },
      "environment": {
        "$ref": "#/components/schemas/SourceEnvironment"
      }
    }
  },
  "Sha256": {
    "type": "string",
    "pattern": "^[0-9a-f]{64}$"
  },
  "Timestamp": {
    "type": "string",
    "format": "date-time"
  },
  "Fqdn": {
    "type": "string"
  },
  "Phase": {
    "type": "string",
    "enum": [
      "Pending",
      "DBInit",
      "AppInit",
      "Ready",
      "Stopped",
      "Paused",
      "Failed"
    ]
  },
  "ActionType": {
    "type": "string",
    "enum": [
      "refresh-data",
      "change-build",
      "stop",
      "start",
      "teardown"
    ]
  },
  "UiConfig": {
    "type": "object",
    "required": [
      "issuer",
      "clientId",
      "audience",
      "apiBase",
      "scope"
    ],
    "properties": {
      "issuer": {
        "type": "string",
        "format": "uri"
      },
      "clientId": {
        "type": "string"
      },
      "audience": {
        "type": "string"
      },
      "apiBase": {
        "type": "string"
      },
      "scope": {
        "type": "string"
      }
    }
  },
  "Me": {
    "type": "object",
    "required": [
      "subject",
      "entitlements",
      "admin"
    ],
    "properties": {
      "subject": {
        "type": "string"
      },
      "username": {
        "type": "string"
      },
      "name": {
        "type": "string"
      },
      "email": {
        "type": "string"
      },
      "entitlements": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/Entitlement"
        }
      },
      "admin": {
        "type": "boolean"
      }
    }
  },
  "Entitlement": {
    "type": "object",
    "required": [
      "customer",
      "environments"
    ],
    "properties": {
      "customer": {
        "$ref": "#/components/schemas/CustomerId"
      },
      "environments": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/SourceEnvironment"
        }
      }
    }
  },
  "EnvironmentList": {
    "type": "object",
    "required": [
      "items"
    ],
    "properties": {
      "items": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/EnvironmentSummary"
        }
      }
    }
  },
  "EnvironmentSummary": {
    "type": "object",
    "required": [
      "name",
      "source",
      "phase"
    ],
    "properties": {
      "name": {
        "$ref": "#/components/schemas/EnvironmentName"
      },
      "source": {
        "$ref": "#/components/schemas/Source"
      },
      "phase": {
        "$ref": "#/components/schemas/Phase"
      },
      "paused": {
        "type": "boolean"
      },
      "deleting": {
        "type": "boolean"
      },
      "tornDown": {
        "type": "boolean"
      },
      "stalled": {
        "$ref": "#/components/schemas/Condition"
      },
      "flavour": {
        "type": "string"
      },
      "createdBy": {
        "type": "string"
      },
      "createdAt": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "url": {
        "type": "string",
        "format": "uri"
      },
      "actionInFlight": {
        "$ref": "#/components/schemas/InFlight"
      },
      "build": {
        "$ref": "#/components/schemas/BuildSummary"
      },
      "backupId": {
        "type": "string"
      },
      "notReady": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/Condition"
        }
      },
      "installationId": {
        "$ref": "#/components/schemas/InstallationId"
      },
      "owner": {
        "type": "string"
      },
      "yourRole": {
        "$ref": "#/components/schemas/YourRole"
      }
    }
  },
  "InstallationId": {
    "type": "string",
    "pattern": "^[A-Z][A-Z0-9]*-[0-9]+$",
    "maxLength": 63
  },
  "Username": {
    "type": "string",
    "pattern": "^[A-Za-z0-9][A-Za-z0-9._@-]{0,127}$"
  },
  "YourRole": {
    "type": "string",
    "enum": [
      "admin",
      "owner",
      "operator",
      "viewer"
    ]
  },
  "Person": {
    "type": "object",
    "required": [
      "username"
    ],
    "properties": {
      "subject": {
        "type": "string"
      },
      "username": {
        "$ref": "#/components/schemas/Username"
      }
    }
  },
  "Member": {
    "type": "object",
    "required": [
      "username",
      "role"
    ],
    "properties": {
      "subject": {
        "type": "string"
      },
      "username": {
        "$ref": "#/components/schemas/Username"
      },
      "role": {
        "type": "string",
        "enum": [
          "viewer",
          "operator"
        ]
      }
    }
  },
  "Access": {
    "type": "object",
    "required": [
      "members"
    ],
    "properties": {
      "owner": {
        "$ref": "#/components/schemas/Person"
      },
      "members": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/Member"
        }
      }
    }
  },
  "AccessChange": {
    "type": "object",
    "required": [
      "members"
    ],
    "properties": {
      "owner": {
        "$ref": "#/components/schemas/Person"
      },
      "members": {
        "type": "array",
        "maxItems": 64,
        "items": {
          "$ref": "#/components/schemas/Member"
        }
      }
    }
  },
  "Classification": {
    "type": "string",
    "enum": [
      "production-raw",
      "sanitized",
      "synthetic"
    ]
  },
  "ClassificationOverride": {
    "type": "object",
    "required": [
      "value",
      "setBy",
      "setAt",
      "holds"
    ],
    "properties": {
      "value": {
        "$ref": "#/components/schemas/Classification"
      },
      "reason": {
        "type": "string",
        "maxLength": 500
      },
      "setBy": {
        "$ref": "#/components/schemas/Person"
      },
      "setAt": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "until": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "backupId": {
        "type": "string"
      },
      "holds": {
        "type": "boolean"
      }
    }
  },
  "ClassificationChange": {
    "type": "object",
    "properties": {
      "value": {},
      "reason": {
        "type": "string",
        "maxLength": 500
      },
      "until": {
        "$ref": "#/components/schemas/Timestamp"
      }
    }
  },
  "DataChecks": {
    "type": "object",
    "required": [
      "acceptedViolations",
      "mayChange",
      "maxAccepted"
    ],
    "properties": {
      "gate": {
        "$ref": "#/components/schemas/GateResult"
      },
      "acceptedViolations": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/AcceptedViolation"
        }
      },
      "mayChange": {
        "type": "boolean"
      },
      "mayChangeReason": {
        "type": "string"
      },
      "maxAccepted": {
        "type": "integer"
      }
    }
  },
  "GateResult": {
    "type": "object",
    "required": [
      "outcome",
      "counts",
      "violations",
      "accepted",
      "unusedAcceptances",
      "broken"
    ],
    "properties": {
      "job": {
        "type": "string"
      },
      "ranAt": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "outcome": {
        "type": "string",
        "enum": [
          "Passed",
          "PassedWithAcceptedViolations",
          "Blocked"
        ]
      },
      "counts": {
        "type": "object",
        "required": [
          "checks",
          "passed",
          "violated",
          "accepted",
          "broken",
          "notApplicable",
          "skipped"
        ],
        "properties": {
          "checks": {
            "type": "integer"
          },
          "passed": {
            "type": "integer"
          },
          "violated": {
            "type": "integer"
          },
          "accepted": {
            "type": "integer"
          },
          "broken": {
            "type": "integer"
          },
          "notApplicable": {
            "type": "integer"
          },
          "skipped": {
            "type": "integer"
          }
        }
      },
      "violations": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/GateFinding"
        }
      },
      "accepted": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/GateFinding"
        }
      },
      "unusedAcceptances": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/ViolationKey"
        }
      },
      "broken": {
        "type": "array",
        "items": {
          "type": "string"
        }
      },
      "moreViolations": {
        "type": "integer"
      },
      "moreAccepted": {
        "type": "integer"
      },
      "moreUnusedAcceptances": {
        "type": "integer"
      },
      "moreBroken": {
        "type": "integer"
      }
    }
  },
  "GateFinding": {
    "type": "object",
    "required": [
      "assertion",
      "subject"
    ],
    "properties": {
      "assertion": {
        "type": "string"
      },
      "subject": {
        "type": "string"
      },
      "detail": {
        "type": "string"
      }
    }
  },
  "ViolationKey": {
    "type": "object",
    "required": [
      "assertion",
      "subject"
    ],
    "properties": {
      "assertion": {
        "type": "string"
      },
      "subject": {
        "type": "string"
      }
    }
  },
  "AcceptedViolation": {
    "type": "object",
    "required": [
      "assertion",
      "subject",
      "reason",
      "binding",
      "lastGate"
    ],
    "properties": {
      "assertion": {
        "type": "string"
      },
      "subject": {
        "type": "string"
      },
      "reason": {
        "type": "string"
      },
      "acceptedBy": {
        "type": "string"
      },
      "acceptedAt": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "datasetGeneration": {
        "type": "integer",
        "format": "int64"
      },
      "backupId": {
        "type": "string"
      },
      "binding": {
        "type": "string",
        "enum": [
          "current",
          "unbound",
          "stale"
        ]
      },
      "lastGate": {
        "type": "string",
        "enum": [
          "used",
          "unused",
          "not-run"
        ]
      }
    }
  },
  "AcceptViolation": {
    "type": "object",
    "required": [
      "assertion",
      "subject",
      "reason"
    ],
    "properties": {
      "assertion": {
        "type": "string",
        "pattern": "^[a-z0-9][a-z0-9-]{0,62}$"
      },
      "subject": {
        "type": "string",
        "minLength": 1,
        "maxLength": 300
      },
      "reason": {
        "type": "string",
        "minLength": 5,
        "maxLength": 500
      }
    }
  },
  "OptionsChange": {
    "type": "object",
    "required": [
      "mitmproxy"
    ],
    "properties": {
      "mitmproxy": {
        "type": "boolean"
      }
    }
  },
  "InstallationIdChange": {
    "type": "object",
    "properties": {
      "installationId": {}
    }
  },
  "BuildSummary": {
    "type": "object",
    "required": [
      "canonicalUrl",
      "deployed"
    ],
    "properties": {
      "canonicalUrl": {
        "type": "string",
        "format": "uri"
      },
      "sha256": {
        "$ref": "#/components/schemas/Sha256"
      },
      "label": {
        "type": "string"
      },
      "deployed": {
        "type": "boolean"
      }
    }
  },
  "Environment": {
    "allOf": [
      {
        "$ref": "#/components/schemas/EnvironmentSummary"
      },
      {
        "type": "object",
        "required": [
          "generation",
          "observedGeneration",
          "conditions",
          "datasetGeneration",
          "spec",
          "action",
          "access",
          "dataClassification",
          "dataAccess"
        ],
        "properties": {
          "access": {
            "$ref": "#/components/schemas/Access"
          },
          "dataClassification": {
            "type": "string",
            "enum": [
              "production-raw",
              "sanitized",
              "synthetic"
            ]
          },
          "detectedClassification": {
            "$ref": "#/components/schemas/Classification"
          },
          "classificationOverride": {
            "$ref": "#/components/schemas/ClassificationOverride"
          },
          "dataChecks": {
            "$ref": "#/components/schemas/DataChecks"
          },
          "dataAccess": {
            "type": "boolean"
          },
          "generation": {
            "type": "integer",
            "format": "int64"
          },
          "observedGeneration": {
            "type": "integer",
            "format": "int64"
          },
          "conditions": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/Condition"
            }
          },
          "datasetGeneration": {
            "type": "integer",
            "format": "int64"
          },
          "operatorVersion": {
            "type": "string"
          },
          "chartVersion": {
            "type": "string"
          },
          "db": {
            "$ref": "#/components/schemas/DbStatus"
          },
          "builds": {
            "$ref": "#/components/schemas/BuildsStatus"
          },
          "images": {
            "$ref": "#/components/schemas/ImagesStatus"
          },
          "spec": {
            "$ref": "#/components/schemas/EnvironmentSpec"
          },
          "action": {
            "$ref": "#/components/schemas/ActionStatus"
          },
          "hosts": {
            "type": "object",
            "properties": {
              "peaksolution": {
                "type": "array",
                "items": {
                  "$ref": "#/components/schemas/Fqdn"
                }
              },
              "cashdesk": {
                "type": "array",
                "items": {
                  "$ref": "#/components/schemas/Fqdn"
                }
              },
              "ticketservice": {
                "type": "array",
                "items": {
                  "$ref": "#/components/schemas/Fqdn"
                }
              },
              "contingentservice": {
                "type": "array",
                "items": {
                  "$ref": "#/components/schemas/Fqdn"
                }
              }
            }
          }
        }
      }
    ]
  },
  "Condition": {
    "type": "object",
    "required": [
      "type",
      "status",
      "reason",
      "message",
      "lastTransitionTime",
      "observedGeneration"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "status": {
        "type": "string",
        "enum": [
          "True",
          "False",
          "Unknown"
        ]
      },
      "reason": {
        "type": "string"
      },
      "message": {
        "type": "string"
      },
      "lastTransitionTime": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "observedGeneration": {
        "type": "integer",
        "format": "int64"
      }
    }
  },
  "ArtefactIdentity": {
    "type": "object",
    "required": [
      "sha256"
    ],
    "properties": {
      "artefactId": {
        "type": "string"
      },
      "canonicalUrl": {
        "type": "string",
        "format": "uri"
      },
      "sha256": {
        "$ref": "#/components/schemas/Sha256"
      }
    }
  },
  "DbStatus": {
    "type": "object",
    "properties": {
      "order": {
        "type": "string"
      },
      "source": {
        "$ref": "#/components/schemas/Source"
      },
      "flavour": {
        "type": "string"
      },
      "backupId": {
        "type": "string"
      },
      "mariadbVersion": {
        "type": "string"
      },
      "base": {
        "$ref": "#/components/schemas/ArtefactIdentity"
      },
      "asserts": {
        "$ref": "#/components/schemas/ArtefactIdentity"
      },
      "patchesApplied": {
        "type": "array",
        "items": {
          "allOf": [
            {
              "$ref": "#/components/schemas/ArtefactIdentity"
            },
            {
              "type": "object",
              "properties": {
                "layer": {
                  "type": "string",
                  "enum": [
                    "preserve",
                    "sanitize",
                    "wire",
                    "tune",
                    "customer"
                  ]
                },
                "customer": {
                  "$ref": "#/components/schemas/CustomerId"
                }
              }
            }
          ]
        }
      },
      "restoredAt": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "preparedAt": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "assertedAt": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "preservedConfig": {
        "type": "object",
        "required": [
          "fromDatasetGeneration"
        ],
        "properties": {
          "fromDatasetGeneration": {
            "type": "integer",
            "format": "int64"
          },
          "captureId": {
            "type": "string"
          },
          "canonicalUrl": {
            "type": "string"
          },
          "sha256": {
            "$ref": "#/components/schemas/Sha256"
          },
          "sizeBytes": {
            "type": "integer",
            "format": "int64"
          },
          "rows": {
            "type": "integer",
            "format": "int64"
          },
          "capturedAt": {
            "$ref": "#/components/schemas/Timestamp"
          }
        }
      }
    }
  },
  "AppArtefact": {
    "type": "object",
    "required": [
      "verification"
    ],
    "properties": {
      "canonicalUrl": {
        "type": "string",
        "format": "uri"
      },
      "sha256": {
        "$ref": "#/components/schemas/Sha256"
      },
      "declared": {
        "$ref": "#/components/schemas/Sha256"
      },
      "observed": {
        "$ref": "#/components/schemas/Sha256"
      },
      "verification": {
        "type": "string",
        "enum": [
          "declared",
          "first-fetch"
        ]
      }
    }
  },
  "AppStatus": {
    "type": "object",
    "properties": {
      "generation": {
        "type": "integer",
        "format": "int64"
      },
      "base": {
        "$ref": "#/components/schemas/AppArtefact"
      },
      "addons": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/AppArtefact"
        }
      },
      "fetchedAt": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "setupAt": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "version": {
        "type": "string"
      },
      "phpRequirement": {
        "type": "string"
      }
    }
  },
  "ImagesStatus": {
    "type": "object",
    "properties": {
      "mysql": {
        "$ref": "#/components/schemas/ImageChoice"
      },
      "php": {
        "$ref": "#/components/schemas/ImageChoice"
      }
    }
  },
  "ImageChoice": {
    "type": "object",
    "properties": {
      "image": {
        "type": "string"
      },
      "source": {
        "type": "string",
        "enum": [
          "spec",
          "catalog",
          "chart"
        ]
      },
      "basis": {
        "type": "string"
      }
    }
  },
  "ServiceBuildStatus": {
    "type": "object",
    "properties": {
      "generation": {
        "type": "integer",
        "format": "int64"
      },
      "canonicalUrl": {
        "type": "string",
        "format": "uri"
      },
      "sha256": {
        "$ref": "#/components/schemas/Sha256"
      },
      "declared": {
        "$ref": "#/components/schemas/Sha256"
      },
      "observed": {
        "$ref": "#/components/schemas/Sha256"
      },
      "verification": {
        "type": "string",
        "enum": [
          "declared",
          "first-fetch"
        ]
      },
      "version": {
        "type": "string"
      },
      "fetchedAt": {
        "$ref": "#/components/schemas/Timestamp"
      }
    }
  },
  "BuildsStatus": {
    "type": "object",
    "properties": {
      "peaksolution": {
        "$ref": "#/components/schemas/AppStatus"
      },
      "cashdesk": {
        "$ref": "#/components/schemas/ServiceBuildStatus"
      },
      "ticketservice": {
        "$ref": "#/components/schemas/ServiceBuildStatus"
      },
      "contingentservice": {
        "$ref": "#/components/schemas/ServiceBuildStatus"
      }
    }
  },
  "EnvironmentSpec": {
    "type": "object",
    "required": [
      "source",
      "order",
      "peaksolution"
    ],
    "properties": {
      "source": {
        "$ref": "#/components/schemas/Source"
      },
      "order": {
        "type": "string"
      },
      "paused": {
        "type": "boolean"
      },
      "peaksolution": {
        "$ref": "#/components/schemas/Peaksolution"
      },
      "cashdesk": {
        "$ref": "#/components/schemas/Service"
      },
      "ticketservice": {
        "$ref": "#/components/schemas/Service"
      },
      "contingentservice": {
        "$ref": "#/components/schemas/Service"
      },
      "mitmproxy": {
        "type": "boolean"
      },
      "fluentbit": {
        "type": "boolean"
      },
      "preserveConfig": {
        "type": "boolean"
      }
    }
  },
  "ActionStatus": {
    "type": "object",
    "properties": {
      "requested": {
        "type": "object",
        "required": [
          "type",
          "id"
        ],
        "properties": {
          "type": {
            "$ref": "#/components/schemas/ActionType"
          },
          "id": {
            "type": "string"
          },
          "expectedDatasetGeneration": {
            "type": "integer",
            "format": "int64"
          },
          "order": {
            "type": "string"
          }
        }
      },
      "inFlight": {
        "$ref": "#/components/schemas/InFlight"
      },
      "history": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/CompletedAction"
        }
      }
    }
  },
  "InFlight": {
    "type": "object",
    "required": [
      "type",
      "id",
      "startedAt"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "startedAt": {
        "$ref": "#/components/schemas/Timestamp"
      }
    }
  },
  "CompletedAction": {
    "type": "object",
    "required": [
      "id",
      "type",
      "outcome",
      "finishedAt"
    ],
    "properties": {
      "id": {
        "type": "string"
      },
      "type": {
        "$ref": "#/components/schemas/ActionType"
      },
      "outcome": {
        "type": "string",
        "enum": [
          "Succeeded",
          "Failed",
          "Rejected"
        ]
      },
      "reason": {
        "type": "string"
      },
      "message": {
        "type": "string"
      },
      "finishedAt": {
        "$ref": "#/components/schemas/Timestamp"
      }
    }
  },
  "Artefact": {
    "type": "object",
    "required": [
      "url"
    ],
    "properties": {
      "url": {
        "type": "string",
        "format": "uri"
      },
      "sha256": {
        "$ref": "#/components/schemas/Sha256"
      }
    }
  },
  "Build": {
    "type": "object",
    "required": [
      "base"
    ],
    "properties": {
      "base": {
        "$ref": "#/components/schemas/Artefact"
      },
      "addons": {
        "type": "array",
        "maxItems": 16,
        "items": {
          "$ref": "#/components/schemas/Artefact"
        }
      }
    }
  },
  "Peaksolution": {
    "type": "object",
    "required": [
      "hosts",
      "build"
    ],
    "properties": {
      "hosts": {
        "type": "array",
        "minItems": 1,
        "items": {
          "$ref": "#/components/schemas/Fqdn"
        }
      },
      "build": {
        "$ref": "#/components/schemas/Build"
      },
      "htaccess": {
        "$ref": "#/components/schemas/Htaccess"
      }
    }
  },
  "Service": {
    "type": "object",
    "properties": {
      "enabled": {
        "type": "boolean"
      },
      "theme": {
        "type": "string"
      },
      "hosts": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/Fqdn"
        }
      },
      "build": {
        "$ref": "#/components/schemas/Artefact"
      }
    }
  },
  "Htaccess": {
    "type": "object",
    "additionalProperties": true
  },
  "CreateEnvironment": {
    "type": "object",
    "required": [
      "name",
      "source",
      "peaksolution"
    ],
    "properties": {
      "name": {
        "$ref": "#/components/schemas/EnvironmentName"
      },
      "source": {
        "$ref": "#/components/schemas/Source"
      },
      "backupId": {
        "type": "string",
        "default": "latest"
      },
      "peaksolution": {
        "$ref": "#/components/schemas/Peaksolution"
      },
      "cashdesk": {
        "$ref": "#/components/schemas/Service"
      },
      "ticketservice": {
        "$ref": "#/components/schemas/Service"
      },
      "contingentservice": {
        "$ref": "#/components/schemas/Service"
      },
      "mitmproxy": {
        "type": "boolean"
      },
      "fluentbit": {
        "type": "boolean"
      },
      "installationId": {
        "$ref": "#/components/schemas/InstallationId"
      }
    }
  },
  "ActionRequest": {
    "type": "object",
    "required": [
      "type"
    ],
    "properties": {
      "type": {
        "$ref": "#/components/schemas/ActionType"
      },
      "confirm": {
        "type": "string"
      },
      "backupId": {
        "type": "string",
        "default": "latest"
      },
      "source": {
        "$ref": "#/components/schemas/Source"
      },
      "preserveConfig": {
        "type": "boolean"
      },
      "peaksolution": {
        "$ref": "#/components/schemas/Build"
      },
      "cashdesk": {
        "$ref": "#/components/schemas/Artefact"
      },
      "ticketservice": {
        "$ref": "#/components/schemas/Artefact"
      },
      "contingentservice": {
        "$ref": "#/components/schemas/Artefact"
      }
    }
  },
  "Accepted": {
    "type": "object",
    "required": [
      "environment"
    ],
    "properties": {
      "environment": {
        "$ref": "#/components/schemas/EnvironmentName"
      },
      "actionId": {
        "type": "string"
      },
      "type": {
        "type": "string"
      },
      "order": {
        "type": "string"
      },
      "expectedDatasetGeneration": {
        "type": "integer",
        "format": "int64"
      }
    }
  },
  "LogValue": {
    "type": "string",
    "pattern": "^[A-Za-z0-9_.:-]{1,64}$"
  },
  "AppLogs": {
    "type": "object",
    "required": [
      "environment",
      "from",
      "to",
      "lines",
      "more"
    ],
    "properties": {
      "environment": {
        "type": "string"
      },
      "from": {
        "type": "string",
        "format": "date-time"
      },
      "to": {
        "type": "string",
        "format": "date-time"
      },
      "lines": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/AppLogLine"
        }
      },
      "more": {
        "type": "boolean"
      },
      "total": {},
      "apps": {},
      "categories": {},
      "histogram": {}
    }
  },
  "AppLogLine": {
    "type": "object",
    "required": [
      "message",
      "fields"
    ],
    "properties": {
      "time": {},
      "level": {},
      "app": {},
      "category": {},
      "message": {
        "type": "string"
      },
      "fields": {
        "type": "object",
        "additionalProperties": {
          "type": "string"
        }
      }
    }
  },
  "LogCount": {
    "type": "object",
    "required": [
      "value",
      "hits"
    ],
    "properties": {
      "value": {
        "type": "string"
      },
      "hits": {
        "type": "integer"
      }
    }
  },
  "LogHistogram": {
    "type": "object",
    "required": [
      "stepSeconds",
      "buckets"
    ],
    "properties": {
      "stepSeconds": {
        "type": "integer"
      },
      "buckets": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/LogCount"
        }
      }
    }
  },
  "MailList": {
    "type": "object",
    "required": [
      "environment",
      "total",
      "start",
      "messages"
    ],
    "properties": {
      "environment": {
        "type": "string"
      },
      "total": {
        "type": "integer",
        "format": "int64"
      },
      "start": {
        "type": "integer"
      },
      "messages": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/MailSummary"
        }
      }
    }
  },
  "MailAddress": {
    "type": "object",
    "required": [
      "address"
    ],
    "properties": {
      "name": {
        "type": "string"
      },
      "address": {
        "type": "string"
      }
    }
  },
  "MailSummary": {
    "type": "object",
    "required": [
      "id",
      "to",
      "size",
      "attachments",
      "read"
    ],
    "properties": {
      "id": {
        "type": "string"
      },
      "from": {},
      "to": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/MailAddress"
        }
      },
      "subject": {
        "type": "string"
      },
      "created": {
        "type": "string",
        "format": "date-time"
      },
      "size": {
        "type": "integer",
        "format": "int64"
      },
      "attachments": {
        "type": "integer"
      },
      "snippet": {
        "type": "string"
      },
      "read": {
        "type": "boolean"
      }
    }
  },
  "Mail": {
    "type": "object",
    "required": [
      "environment",
      "id",
      "to",
      "cc",
      "bcc",
      "replyTo",
      "size",
      "attachments"
    ],
    "properties": {
      "environment": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "messageId": {
        "type": "string"
      },
      "from": {},
      "to": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/MailAddress"
        }
      },
      "cc": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/MailAddress"
        }
      },
      "bcc": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/MailAddress"
        }
      },
      "replyTo": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/MailAddress"
        }
      },
      "subject": {
        "type": "string"
      },
      "date": {
        "type": "string",
        "format": "date-time"
      },
      "text": {
        "type": "string"
      },
      "html": {
        "type": "string"
      },
      "size": {
        "type": "integer",
        "format": "int64"
      },
      "attachments": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/MailPart"
        }
      }
    }
  },
  "MailPart": {
    "type": "object",
    "required": [
      "partId",
      "size"
    ],
    "properties": {
      "partId": {
        "type": "string"
      },
      "fileName": {
        "type": "string"
      },
      "contentType": {
        "type": "string"
      },
      "size": {
        "type": "integer",
        "format": "int64"
      }
    }
  },
  "DbSchema": {
    "type": "object",
    "required": [
      "environment",
      "databases"
    ],
    "properties": {
      "environment": {
        "type": "string"
      },
      "databases": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/DbDatabase"
        }
      }
    }
  },
  "DbDatabase": {
    "type": "object",
    "required": [
      "name",
      "tables"
    ],
    "properties": {
      "name": {
        "type": "string"
      },
      "tables": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/DbTable"
        }
      }
    }
  },
  "DbTable": {
    "type": "object",
    "required": [
      "name"
    ],
    "properties": {
      "name": {
        "type": "string"
      },
      "type": {
        "type": "string"
      },
      "rows": {},
      "bytes": {}
    }
  },
  "DbQuery": {
    "type": "object",
    "required": [
      "sql"
    ],
    "properties": {
      "database": {},
      "sql": {
        "type": "string",
        "minLength": 1,
        "maxLength": 20000
      },
      "limit": {
        "type": "integer",
        "minimum": 1,
        "maximum": 1000,
        "default": 200
      },
      "write": {}
    }
  },
  "DbResult": {
    "type": "object",
    "required": [
      "environment",
      "columns",
      "rows",
      "more",
      "clipped",
      "elapsedMs"
    ],
    "properties": {
      "environment": {
        "type": "string"
      },
      "database": {},
      "columns": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/DbColumn"
        }
      },
      "rows": {
        "type": "array",
        "items": {
          "type": "array",
          "items": {}
        }
      },
      "more": {
        "type": "boolean"
      },
      "clipped": {
        "type": "boolean"
      },
      "elapsedMs": {
        "type": "integer",
        "format": "int64"
      },
      "write": {}
    }
  },
  "DbWrite": {
    "type": "object",
    "required": [
      "mode",
      "rows",
      "committed",
      "warnings"
    ],
    "properties": {
      "mode": {
        "type": "string",
        "enum": [
          "preview",
          "commit"
        ]
      },
      "rows": {
        "type": "integer",
        "format": "int64"
      },
      "committed": {
        "type": "boolean"
      },
      "warnings": {
        "type": "array",
        "items": {
          "type": "string"
        }
      }
    }
  },
  "DbColumn": {
    "type": "object",
    "required": [
      "name",
      "type"
    ],
    "properties": {
      "name": {
        "type": "string"
      },
      "type": {
        "type": "string"
      }
    }
  },
  "ShopLogin": {
    "type": "object",
    "required": [
      "url"
    ],
    "properties": {
      "url": {
        "type": "string"
      }
    }
  },
  "BackupList": {
    "type": "object",
    "required": [
      "items"
    ],
    "properties": {
      "items": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/Backup"
        }
      },
      "nextCursor": {
        "type": "string"
      }
    }
  },
  "Backup": {
    "type": "object",
    "required": [
      "backupId",
      "source",
      "flavour",
      "takenAt",
      "sizeBytes"
    ],
    "properties": {
      "backupId": {
        "type": "string"
      },
      "source": {
        "$ref": "#/components/schemas/Source"
      },
      "flavour": {
        "type": "string"
      },
      "takenAt": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "retainedUntil": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "sizeBytes": {
        "type": "integer",
        "format": "int64"
      },
      "mariadbVersion": {
        "type": "string"
      }
    }
  },
  "BuildList": {
    "type": "object",
    "required": [
      "branches",
      "items"
    ],
    "properties": {
      "branches": {
        "type": "array",
        "items": {
          "type": "string"
        }
      },
      "items": {
        "type": "array",
        "items": {
          "$ref": "#/components/schemas/BuildArtefact"
        }
      },
      "truncated": {
        "type": "boolean"
      }
    }
  },
  "BuildArtefact": {
    "type": "object",
    "required": [
      "branch",
      "pipeline",
      "file",
      "url"
    ],
    "properties": {
      "branch": {
        "type": "string"
      },
      "pipeline": {
        "type": "string"
      },
      "file": {
        "type": "string"
      },
      "url": {
        "type": "string",
        "format": "uri"
      },
      "sizeBytes": {
        "type": "integer",
        "format": "int64"
      },
      "lastModified": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "sha256": {
        "$ref": "#/components/schemas/Sha256"
      },
      "release": {
        "$ref": "#/components/schemas/BuildRelease"
      }
    }
  },
  "BuildRelease": {
    "type": "object",
    "required": [
      "id"
    ],
    "properties": {
      "id": {
        "type": "string"
      },
      "name": {
        "type": "string"
      },
      "buildNumber": {
        "type": "string"
      },
      "variant": {
        "type": "string"
      },
      "commit": {
        "type": "string"
      },
      "releaseTime": {
        "$ref": "#/components/schemas/Timestamp"
      },
      "enabled": {
        "type": "boolean"
      },
      "pipelineStatus": {
        "type": "string"
      },
      "pipelineUrl": {
        "type": "string",
        "format": "uri"
      },
      "createdBy": {
        "type": "string"
      }
    }
  },
  "Problem": {
    "type": "object",
    "required": [
      "type",
      "title",
      "status",
      "code",
      "detail"
    ],
    "properties": {
      "type": {
        "type": "string",
        "format": "uri"
      },
      "title": {
        "type": "string"
      },
      "status": {
        "type": "integer"
      },
      "detail": {
        "type": "string"
      },
      "instance": {
        "type": "string"
      },
      "code": {
        "type": "string",
        "enum": [
          "Unauthenticated",
          "InvalidRequest",
          "ConfirmationRequired",
          "NotEntitled",
          "NotPermitted",
          "NoUsername",
          "EnvironmentNotFound",
          "BackupNotFound",
          "EnvironmentExists",
          "ActionInFlight",
          "ActionRejected",
          "AdmissionDenied",
          "Conflict",
          "TornDown",
          "BackupRetired",
          "Invalid",
          "EntitlementsUnavailable",
          "BackupServiceUnavailable",
          "BuildsUnavailable",
          "BuildsRefused",
          "KubernetesUnavailable",
          "InternalError",
          "NotFound",
          "MethodNotAllowed",
          "BackupServiceRefused",
          "NotConfigured",
          "NoGateResult",
          "NotReported",
          "AlreadyAccepted",
          "TooManyAcceptances",
          "AcceptanceNotFound",
          "LogsNotConfigured",
          "LogsUnavailable",
          "StatementNotAllowed",
          "QueryFailed",
          "DbConsoleNotConfigured",
          "DatabaseUnavailable",
          "WriteNotRequested",
          "TooManyRows",
          "DbWritesNotConfigured",
          "MailNotConfigured",
          "MailUnavailable",
          "MailNotFound"
        ]
      },
      "reason": {
        "type": "string"
      }
    }
  }
};
